import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxif">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxif')}
            </Typography>
            <p><strong>{translate('fxif')}</strong> trả về kết quả 1 nếu kiểm tra là đúng, trả về kết quả 2 nếu kiểm tra là sai.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là điều kiện.</td>
                                <td>Day() = 1</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}1<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Là kết quả 1.</td>
                                <td>"Beginning of the month"</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}2<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Là kết quả 2.</td>
                                <td>""</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. If( Day() = 1 , "Beginning of the month" , "" ) trả về "" nếu ngày hôm nay không phải là ngày 1 của tháng và ngược lại.</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxcase">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxcase')}
            </Typography>
            <p><strong>{translate('fxcase')}</strong> đánh giá từng diều kiện theo thứ tự từ trái sang phải và khi tìm thấy điều kiện đúng thì trả về giá trị được chỉ định trong kết quả ở điều kiện đó. Nếu không có điều kiện nào đúng thì sẽ trả về kết quả mặc định.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')},{translate('results')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là điều kiện và kết quả trả về nếu điều kiện là đúng.</td>
                                <td>[[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]]</td>
                            </tr>
                            <tr>
                                <td>{translate('number')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Là giá trị bất kì.</td>
                                <td>"Late"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Case( [[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]] , "Late" ) trả về "Early" nếu ngày hôm nay nhỏ hơn hoặc bằng 10, trả về "Mid" nếu ngày hôm nay lớn hơn 10 và nhỏ hơn hoặc bằng 20, ngoài ra sẽ trả lại "Late".</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxisempty">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxisempty')}
            </Typography>
            <p><strong>{translate('fxisempty')}</strong> trả về (true) nếu trống hoặc nếu xảy ra lỗi khác, ngược lại trả về (false).</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"text"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IsEmpty("text") trả về false</div>
                    <div>2. IsEmpty("") trả về true</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);